import { imageurl } from './../../constant/constant';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from './../../services/data.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddmapdataComponent } from './addmapdata/addmapdata.component';
import { EditmapdataComponent } from './editmapdata/editmapdata.component';
import { ConfirmModalComponent } from 'src/app/modal/confirm-modal/confirm-modal.component';
import { Subscription } from 'rxjs';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { SubscriptionStatus } from '../subscription/models/subscription-usage.model';
import { MapInviteModalComponent } from '../map-invite-modal/map-invite-modal.component';
import { WikiService } from 'src/app/services/wiki.service';
import { MapData } from 'src/app/models/map.model';
import { ToastService } from 'src/app/services/toast.service';
import { AzgaarMapGeneratorInfoComponent } from './azgaar-map-generator-info/azgaar-map-generator-info.component';
import { ViewportService } from 'src/app/services/viewport.service';
import { MapService } from 'src/app/services/map.service';
import { WorldBuilderModalComponent } from '../../features/world-builder/modal/world-builder-modal.component';
import { WizardStateService } from '../../features/world-builder/services/wizard-state.service';

@Component({
  selector: 'app-maplist',
  templateUrl: './maplist.component.html',
  styleUrls: ['./maplist.component.scss'],
  standalone: false,
})
export class MaplistComponent implements OnInit, OnDestroy {
  maplistdata: MapData[] | null = [];
  imageurl = imageurl;
  user_id: any;
  isClassAdded = false;
  planUsageSubscription: Subscription;
  planUsage: SubscriptionStatus | null = null;
  mapListSubscription: Subscription;
  viewportSubscription: Subscription;
  activePath: string = '';
  navigateBackGame: boolean = false;
  todayDate: string = new Date().toISOString();

  selectedTab: 'all' | 'mine' = 'all';
  viewMode: 'large' | 'small' = 'large';
  isMobile = false;
  private preferredViewMode: 'large' | 'small' = 'large';

  // Each map in the list carries its build status (backend build_status);
  // while something is still being built the list refreshes itself.
  private buildRefreshTimer: any = null;
  retrying: { [mapId: string]: boolean } = {};

  setViewMode(mode: 'large' | 'small') {
    this.preferredViewMode = mode;
    this.viewMode = mode;
  }

  get myMaps(): MapData[] {
    return (this.maplistdata || []).filter((m: any) => m.user_id === this.user_id);
  }

  get visibleMaps(): MapData[] {
    return this.selectedTab === 'mine' ? this.myMaps : (this.maplistdata || []);
  }

  mapImg(map: any): string {
    return map?.image && map.image !== 'Map not found'
      ? this.imageurl + map.image + '?t=' + this.todayDate
      : 'assets/images/poster-map.png';
  }

  mapCreator(map: any): string {
    return map?.creator?.display_name || map?.creator?.name || 'Unknown';
  }

  constructor(
    private dataserv: DataService,
    private router: Router,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private currentUserService: CurrentUserService,
    private wikiService: WikiService,
    private mapService: MapService,
    private toasterService: ToastService,
    private viewport: ViewportService,
    private stateService: WizardStateService,
    private cdr: ChangeDetectorRef,
  ) {
    this.isClassAdded = true;
  }

  ngOnInit(): void {
    this.viewportSubscription = this.viewport.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
      this.viewMode = isMobile ? 'large' : this.preferredViewMode;
      this.cdr.detectChanges();
    });
    this.activePath = localStorage.getItem('activePath') || '';
    this.route.queryParams.subscribe((params) => {
      if (params['game']) {
        this.navigateBackGame = true;
      }
      this.cdr.detectChanges();
    });

    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = data.id;
        this.getmaplist();
      }
      this.cdr.detectChanges();
    });

    this.planUsageSubscription = this.currentUserService.planUsageData.subscribe(
      (data: SubscriptionStatus) => {
        if (data) {
          this.planUsage = data;
          this.cdr.detectChanges();
        }
      },
    );

    this.mapListSubscription = this.mapService.mapList$.subscribe((maps) => {
      this.maplistdata = maps;
      this.watchBuilds();
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.viewportSubscription?.unsubscribe();
    this.planUsageSubscription?.unsubscribe();
    this.mapListSubscription?.unsubscribe();
    clearTimeout(this.buildRefreshTimer);
  }

  getmaplist(force: boolean = true) {
    this.mapService.getMapList(this.user_id, force);
  }

  openAzgaarMapGeneratorInfo() {
    this.modalService.open(AzgaarMapGeneratorInfoComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true,
    });
  }

  isMapUploadDisabled(): boolean {
    if (!this.planUsage) return false;
    const feature = this.planUsage.subscription_features;
    const usage = this.planUsage.usage;

    if (!feature.upload_maps) return true;

    if (feature.maps_uploaded === -1) return false;

    return usage.maps_uploaded >= feature.maps_uploaded;
  }

  shouldShowMapUploadLimitReached(): boolean {
    if (!this.planUsage) return false;

    const feature = this.planUsage.subscription_features;
    const usage = this.planUsage.usage;

    if (feature.maps_uploaded === -1) return false;

    return usage.maps_uploaded >= feature.maps_uploaded;
  }

  isGameCreateDisabled() {
    if (!this.planUsage) return false;
    const feature = this.planUsage.subscription_features;
    const usage = this.planUsage.usage;

    if (feature.max_games_created === -1) return false;

    return usage.games_created >= feature.max_games_created;
  }

  handleSubscribeNavigate() {
    this.router.navigate(['/subscription'], {
      queryParams: {
        isUser: this.user_id ? true : false,
        showPlans: true,
      },
    });
  }

  addmap(event: any) {
    const addmodalRef = this.modalService.open(AddmapdataComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });
    addmodalRef.result.then((res) => {
      if (res) {
        this.getmaplist();
      }
      this.cdr.detectChanges();
    });
  }

  openWorldBuilder() {
    if (!this.user_id) {
      this.router.navigate(['/login']);
      return;
    }
    this.stateService.resetState();
    const modalRef = this.modalService.open(WorldBuilderModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      windowClass: 'world-builder-modal-window',
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.getmaplist();
        }
        this.cdr.detectChanges();
      },
      () => {},
    );
  }

  editmap(data: any) {
    const editmodalRef = this.modalService.open(EditmapdataComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });
    editmodalRef.componentInstance.id = data.map_id;
    editmodalRef.result.then((res) => {
      if (res) {
        this.getmaplist();
      }
      this.cdr.detectChanges();
    });
  }

  deletemap(map_id: any) {
    const deletemodalRef = this.modalService.open(ConfirmModalComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    deletemodalRef.componentInstance.title = 'Delete Confirmation';
    deletemodalRef.componentInstance.message = 'Are you sure you want to delete this map?';
    deletemodalRef.componentInstance.confirmLabel = 'Delete';
    deletemodalRef.componentInstance.confirmClick.subscribe(() => {
      deletemodalRef.componentInstance.isLoading = true;
      this.dataserv.deletemap(map_id, this.user_id).subscribe((res) => {
        if (res) {
          this.toasterService.showSuccess('Map deleted.', 'success');
          deletemodalRef.close(true);
        } else {
          deletemodalRef.componentInstance.isLoading = false;
        }
      });
    });
    deletemodalRef.result.then((res) => {
      if (res) {
        this.getmaplist();
      }
      this.cdr.detectChanges();
    });
  }

  invite(map_id: any) {
    const addmodalRef = this.modalService.open(MapInviteModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });
    addmodalRef.componentInstance.map_id = map_id;
    addmodalRef.componentInstance.updateData.subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  viewMap(map_id: string) {
    this.router.navigate(['/map/' + map_id]);
  }

  newGame(map: any) {
    if (this.navigateBackGame) {
      this.router.navigate(['/create-game/' + map.map_id]);
    } else {
      this.router.navigate(['/activegames'], {
        queryParams: { tab: 'createModal' },
      });
    }
  }

  viewWiki(map: any) {
    this.wikiService.openMapWiki(map.map_id, map.map_name);
  }

  modifyMap(map: any) {
    this.router.navigate(['/map-modify/' + map.map_id]);
  }

  /** Refresh the list in 30s while a map is still being built or its
   * terrain painted: one request for all maps. */
  private watchBuilds(): void {
    clearTimeout(this.buildRefreshTimer);
    const busy = (this.maplistdata || []).some(
      (m: any) => this.isBuilding(m) || m?.build?.terrain === 'painting',
    );
    if (busy) this.buildRefreshTimer = setTimeout(() => this.getmaplist(true), 30000);
  }

  isBuilding(map: any): boolean {
    return ['uploading', 'setting_up', 'writing_lore'].includes(map?.build?.state);
  }

  buildPercent(map: any): number {
    const b = map?.build;
    return b?.state === 'writing_lore' ? b.lore_percent ?? 0 : b?.wizard_percent ?? 0;
  }

  showBuildError(map: any): void {
    this.toasterService.showSuccess(map?.build?.error || 'Building this world stopped.', 'danger');
  }

  retryBuild(map: any): void {
    if (this.retrying[map.map_id]) return;
    this.retrying[map.map_id] = true;
    this.dataserv.retryWorldCreation(map.map_id).subscribe({
      next: () => {
        this.retrying[map.map_id] = false;
        this.toasterService.showSuccess("Building your world again. We'll let you know when it's ready.", 'success');
        this.getmaplist(true);
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.retrying[map.map_id] = false;
        this.toasterService.showSuccess(err?.error?.error || "We couldn't restart it. Please try again.", 'danger');
        this.cdr.detectChanges();
      },
    });
  }
}
